
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30823',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30823",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55360",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8365",
  "hubspot-dlb": "static-2.1905",
  "HubStyleTokens": "static-2.11824",
  "I18n": "static-7.1678",
  "quartz": "static-1.7496",
  "quartz-config": "static-1.1274",
  "quartz-core": "static-1.6715",
  "react-dlb": "static-1.89",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.80",
  "reselect": "static-3.12",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.955",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55347",
  "feedback-utils": "static-1.55351",
  "forms-embed-utils-lib": "static-1.4797",
  "forms-utils-lib": "static-1.13129",
  "foundations-assets": "static-1.5217",
  "foundations-components": "static-1.8533",
  "foundations-theming": "static-1.4809",
  "hub-http": "static-1.6544",
  "hubspot-url-utils": "static-1.4366",
  "HubStyle": "static-2.12131",
  "icons": "static-2.692",
  "immutable": "static-2.87",
  "quick-fetch": "static-1.4150",
  "raven": "static-3.5925",
  "react": "static-7.196",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.79",
  "react-rhumb": "static-1.17055",
  "react-select-plus": "static-1.113",
  "react-utils": "static-2.5578",
  "react-virtualized": "static-2.107",
  "redux": "static-4.80",
  "StyleGuideUI": "static-3.506",
  "tinymce-plugins": "static-1.58267",
  "transmute": "static-2.97",
  "ui-images": "static-2.1260",
  "UIComponents": "static-3.8770",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9963",
  "styled-components": "static-2.99",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3773",
  "quartz-webpack": "static-1.3720",
  "foundations-theming-specialty": "static-1.2525",
  "property-description-translator": "static-1.4171",
  "HeadJS": "static-2.802",
  "framer-motion": "static-1.79",
  "hs-test-utils-bend-plugin": "static-1.3476",
  "msw": "static-1.39",
  "testing-library": "static-1.158",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.230",
  "moment-timezone": "static-5.91",
  "jasmine": "static-4.4645",
  "jasmine-runner": "static-1.6783",
  "opentelemetry-fe-types": "static-1.110",
  "dispatcher": "static-1.143",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.886",
  "hubspotter-http": "static-1.4886",
  "mobile-manifest-mixins": "static-1.582",
  "module-federation": "static-1.33",
  "opentelemetry-fe": "static-1.485",
  "quartz-auth": "static-1.1171",
  "quartz-head": "static-1.1161",
  "quartz-i18n": "static-1.1171",
  "quartz-routing": "static-1.926",
  "quartz-test": "static-1.1171",
  "quartz-tracking": "static-1.875",
  "trellis-components": "static-1.2738",
  "ui-fonts": "static-1.1086",
  "usage-tracker-container": "static-1.7636",
  "usage-tracker-core": "static-1.7496",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.221",
  "conversations-skeleton-state": "static-1.7580",
  "reference-resolvers": "static-1.8513",
  "sanitize-text": "static-1.8490",
  "PatternValidationJS": "static-1.3226",
  "ReduxMessenger": "static-2.10703",
  "outpost": "static-1.4486",
  "rpc-client-utils": "static-1.4998",
  "sanitize": "static-1.4805",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4802",
  "floating-ui": "static-1.63",
  "hs-story-utils": "static-1.9757",
  "react-aria": "static-1.72",
  "react-create-root-preference": "static-1.77",
  "tanstack-table": "static-1.61",
  "trellis-assets": "static-1.2719",
  "bend-plugin-foundations-theming": "static-1.3292",
  "foundations-theming-base": "static-1.3794",
  "stylex": "static-1.41",
  "hs-locale-management": "static-1.317",
  "csstype": "static-1.50",
  "web-vitals": "static-1.15",
  "ai-components-ui-library": "static-1.9774",
  "atom": "static-1.5415",
  "codemirror": "static-5.102",
  "content-assistance-lib": "static-1.8235",
  "ContentUtils": "static-1.69179",
  "data-token-picker": "static-1.16924",
  "file-manager-components": "static-1.24567",
  "FileManagerCore": "static-1.40066",
  "FileManagerLib": "static-1.40207",
  "frontend-preferences-client": "static-1.8251",
  "hub-http-contrib": "static-1.3372",
  "interframe": "static-3.5088",
  "layout-dnd-components": "static-1.13009",
  "layout-dnd-utils": "static-1.11984",
  "property-translator": "static-1.5728",
  "react-codemirror": "static-1.10976",
  "react-colorpicker": "static-2.10546",
  "reference-resolvers-lite": "static-1.8437",
  "rich-text-lib": "static-1.20344",
  "tinymce-data": "static-1.41238",
  "tinymce-themes": "static-1.57123",
  "ui-addon-emoji-picker": "static-1.10217",
  "ui-addon-sales-email": "static-1.5547",
  "ui-brand-identity-lib": "static-1.16591",
  "bender-build-tools": "static-1.3452",
  "opentelemetry-web": "static-1.15",
  "beacon-keepalive-queue": "static-1.37",
  "hub-http-shared-msw-handlers": "static-1.10664",
  "hubspotter-http-shared-msw-handlers": "static-1.10662",
  "usage-tracker-session-replay": "static-1.5332",
  "base-ui": "static-1.22",
  "react-day-picker": "static-1.10",
  "trellis-theming": "static-1.1305",
  "tanstack-virtual": "static-1.38",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.408",
  "chirp-fetch": "static-1.2228",
  "stylex-utils": "static-1.146",
  "chatspot-core": "static-1.23167",
  "copilot-toolkit": "static-1.11891",
  "customer-data-objects-ui-components": "static-1.13364",
  "data-fetching-client": "static-1.9985",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5090",
  "ui-addon-video-player": "static-1.9035",
  "ui-coaching-tips": "static-1.29356",
  "usage-tracker": "static-1.7646",
  "cms-field-types": "static-1.5145",
  "content-icons-ui": "static-1.2396",
  "integrations-lib": "static-1.17103",
  "customer-data-objects": "static-1.8030",
  "apollo-dlb": "static-3.98",
  "breeze-engine-lib": "static-1.1812",
  "apollo-link-hub-http": "static-2.4990",
  "apollo-stack-hubspot": "static-3.94",
  "graphql": "static-1.89",
  "immer": "static-1.101",
  "immerable": "static-1.4479",
  "ui-addon-iframeable": "static-1.9409",
  "video-components-external": "static-1.12191",
  "video-data-lib": "static-1.35849",
  "breeze-artifacts-sdk": "static-1.426",
  "audio-components": "static-1.6382",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29848",
  "FileManagerImages": "static-1.37718",
  "foundations-components-legacy": "static-1.1558",
  "html-to-image": "static-1.61",
  "redux-toolkit": "static-1.78",
  "salesImages": "static-1.593",
  "ui-universal-auth": "static-1.9451",
  "urlinator": "static-1.4863",
  "video-components": "static-1.14193",
  "video-embed": "static-1.36683",
  "ts-schema": "static-1.4316",
  "ContentData": "static-1.69254",
  "layout-data-lib": "static-1.10309",
  "react-dnd-compat": "static-1.4949",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1878",
  "external-options-client-types": "static-1.4363",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7226",
  "hs-promise-utils": "static-1.5923",
  "inbound-db-properties-service-client": "static-1.4070",
  "NamespacedHubStyle": "static-2.9288",
  "growth-onboarding-confetti": "static-1.3397",
  "SharedI18nStrings": "static-1.183",
  "ui-addon-i18n": "static-1.11478",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5780",
  "magpie-types": "static-1.5240",
  "simple-logging-lib": "static-1.3383",
  "avatar-components": "static-1.2814",
  "customer-data-ui-utilities": "static-1.10163",
  "growth-onboarding-feedback-components": "static-1.6916",
  "flux-actions": "static-1.372",
  "hubspot-apollo-client": "static-1.5209",
  "integrations-error-boundary-lib": "static-1.14518",
  "integrations-tracking-lib": "static-1.5941",
  "laboratory-lib": "static-3.7486",
  "native-integrations-shared-strings": "static-1.8110",
  "redux-observable": "static-1.75",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10601",
  "unified-auth": "static-1.965",
  "breeze-engine-chat-components": "static-1.790",
  "breeze-engine-core": "static-1.1090",
  "ably": "static-2.2",
  "highlight.js": "static-1.86",
  "pulse": "static-1.961",
  "navigation-messaging": "static-1.8210",
  "content-media-composition-data-lib": "static-1.13295",
  "content-media-compositions": "static-2.17302",
  "idb-keyval": "static-1.51",
  "media-bridge-lib": "static-1.19441",
  "unified-auth-core-lib": "static-1.1247",
  "social-insights-client-types": "static-1.22706",
  "advanced-menus-core": "static-1.15614",
  "advanced-menus-lib": "static-1.12487",
  "ExportDialog": "static-6.10711",
  "ui-memberships-settings-lib": "static-1.34891",
  "conditional-properties-service-client": "static-1.4039",
  "crm-pipelines-api-client-types": "static-1.4370",
  "fdsr-migration-layer": "static-1.345",
  "framework-builder-read-service-client": "static-1.4244",
  "framework-data-schema-quick-fetch": "static-1.7131",
  "inbound-db-meta-service-client": "static-1.3718",
  "multi-currency-client-types": "static-1.3930",
  "persist-promise": "static-1.4035",
  "foundations-components-test-utils": "static-1.6016",
  "reactive-lib": "static-1.1050",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.668",
  "universal-page-editor-lib": "static-1.3341",
  "adobe-sign-auth-lib": "static-1.515",
  "ads-unified-auth-lib": "static-1.1487",
  "custom-vendor-connection-lib": "static-1.15",
  "google-sheets-integration-lib": "static-1.1078",
  "microsoft-drive-auth-lib": "static-1.193",
  "surveymonkey-integration-lib": "static-1.534",
  "slack-ui-library": "static-1.10731",
  "bend-plugin-pulse": "static-1.464",
  "event-emitter": "static-1.1288",
  "fast-json-patch": "static-1.70",
  "js-cookie": "static-1.18",
  "fsm": "static-1.4084",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15613",
  "simple-menus-lib": "static-1.17130",
  "settings-ui-lib": "static-1.12857",
  "crm-record-cards-service-types": "static-1.3796",
  "location-customization-utils-lib": "static-1.10148",
  "react-flip-move": "static-1.78"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30823",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55360",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8365",
  "hubspot-dlb": "/hubspot-dlb/static-2.1905",
  "HubStyleTokens": "/HubStyleTokens/static-2.11824",
  "I18n": "/I18n/static-7.1678",
  "quartz": "/quartz/static-1.7496",
  "quartz-config": "/quartz-config/static-1.1274",
  "quartz-core": "/quartz-core/static-1.6715",
  "react-dlb": "/react-dlb/static-1.89",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.80",
  "reselect": "/reselect/static-3.12",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.955",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55347",
  "feedback-utils": "/feedback-utils/static-1.55351",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4797",
  "forms-utils-lib": "/forms-utils-lib/static-1.13129",
  "foundations-assets": "/foundations-assets/static-1.5217",
  "foundations-components": "/foundations-components/static-1.8533",
  "foundations-theming": "/foundations-theming/static-1.4809",
  "hub-http": "/hub-http/static-1.6544",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4366",
  "HubStyle": "/HubStyle/static-2.12131",
  "icons": "/icons/static-2.692",
  "immutable": "/immutable/static-2.87",
  "quick-fetch": "/quick-fetch/static-1.4150",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.196",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.79",
  "react-rhumb": "/react-rhumb/static-1.17055",
  "react-select-plus": "/react-select-plus/static-1.113",
  "react-utils": "/react-utils/static-2.5578",
  "react-virtualized": "/react-virtualized/static-2.107",
  "redux": "/redux/static-4.80",
  "StyleGuideUI": "/StyleGuideUI/static-3.506",
  "tinymce-plugins": "/tinymce-plugins/static-1.58267",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1260",
  "UIComponents": "/UIComponents/static-3.8770",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9963",
  "styled-components": "/styled-components/static-2.99",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3773",
  "quartz-webpack": "/quartz-webpack/static-1.3720",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2525",
  "property-description-translator": "/property-description-translator/static-1.4171",
  "HeadJS": "/HeadJS/static-2.802",
  "framer-motion": "/framer-motion/static-1.79",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3476",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.158",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.230",
  "moment-timezone": "/moment-timezone/static-5.91",
  "jasmine": "/jasmine/static-4.4645",
  "jasmine-runner": "/jasmine-runner/static-1.6783",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.110",
  "dispatcher": "/dispatcher/static-1.143",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.886",
  "hubspotter-http": "/hubspotter-http/static-1.4886",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.582",
  "module-federation": "/module-federation/static-1.33",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.485",
  "quartz-auth": "/quartz-auth/static-1.1171",
  "quartz-head": "/quartz-head/static-1.1161",
  "quartz-i18n": "/quartz-i18n/static-1.1171",
  "quartz-routing": "/quartz-routing/static-1.926",
  "quartz-test": "/quartz-test/static-1.1171",
  "quartz-tracking": "/quartz-tracking/static-1.875",
  "trellis-components": "/trellis-components/static-1.2738",
  "ui-fonts": "/ui-fonts/static-1.1086",
  "usage-tracker-container": "/usage-tracker-container/static-1.7636",
  "usage-tracker-core": "/usage-tracker-core/static-1.7496",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.221",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7580",
  "reference-resolvers": "/reference-resolvers/static-1.8513",
  "sanitize-text": "/sanitize-text/static-1.8490",
  "PatternValidationJS": "/PatternValidationJS/static-1.3226",
  "ReduxMessenger": "/ReduxMessenger/static-2.10703",
  "outpost": "/outpost/static-1.4486",
  "rpc-client-utils": "/rpc-client-utils/static-1.4998",
  "sanitize": "/sanitize/static-1.4805",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4802",
  "floating-ui": "/floating-ui/static-1.63",
  "hs-story-utils": "/hs-story-utils/static-1.9757",
  "react-aria": "/react-aria/static-1.72",
  "react-create-root-preference": "/react-create-root-preference/static-1.77",
  "tanstack-table": "/tanstack-table/static-1.61",
  "trellis-assets": "/trellis-assets/static-1.2719",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3292",
  "foundations-theming-base": "/foundations-theming-base/static-1.3794",
  "stylex": "/stylex/static-1.41",
  "hs-locale-management": "/hs-locale-management/static-1.317",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.15",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9774",
  "atom": "/atom/static-1.5415",
  "codemirror": "/codemirror/static-5.102",
  "content-assistance-lib": "/content-assistance-lib/static-1.8235",
  "ContentUtils": "/ContentUtils/static-1.69179",
  "data-token-picker": "/data-token-picker/static-1.16924",
  "file-manager-components": "/file-manager-components/static-1.24567",
  "FileManagerCore": "/FileManagerCore/static-1.40066",
  "FileManagerLib": "/FileManagerLib/static-1.40207",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8251",
  "hub-http-contrib": "/hub-http-contrib/static-1.3372",
  "interframe": "/interframe/static-3.5088",
  "layout-dnd-components": "/layout-dnd-components/static-1.13009",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11984",
  "property-translator": "/property-translator/static-1.5728",
  "react-codemirror": "/react-codemirror/static-1.10976",
  "react-colorpicker": "/react-colorpicker/static-2.10546",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8437",
  "rich-text-lib": "/rich-text-lib/static-1.20344",
  "tinymce-data": "/tinymce-data/static-1.41238",
  "tinymce-themes": "/tinymce-themes/static-1.57123",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10217",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5547",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16591",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "opentelemetry-web": "/opentelemetry-web/static-1.15",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.37",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10664",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10662",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5332",
  "base-ui": "/base-ui/static-1.22",
  "react-day-picker": "/react-day-picker/static-1.10",
  "trellis-theming": "/trellis-theming/static-1.1305",
  "tanstack-virtual": "/tanstack-virtual/static-1.38",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.408",
  "chirp-fetch": "/chirp-fetch/static-1.2228",
  "stylex-utils": "/stylex-utils/static-1.146",
  "chatspot-core": "/chatspot-core/static-1.23167",
  "copilot-toolkit": "/copilot-toolkit/static-1.11891",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13364",
  "data-fetching-client": "/data-fetching-client/static-1.9985",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5090",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9035",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29356",
  "usage-tracker": "/usage-tracker/static-1.7646",
  "cms-field-types": "/cms-field-types/static-1.5145",
  "content-icons-ui": "/content-icons-ui/static-1.2396",
  "integrations-lib": "/integrations-lib/static-1.17103",
  "customer-data-objects": "/customer-data-objects/static-1.8030",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1812",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4990",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "graphql": "/graphql/static-1.89",
  "immer": "/immer/static-1.101",
  "immerable": "/immerable/static-1.4479",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9409",
  "video-components-external": "/video-components-external/static-1.12191",
  "video-data-lib": "/video-data-lib/static-1.35849",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.426",
  "audio-components": "/audio-components/static-1.6382",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29848",
  "FileManagerImages": "/FileManagerImages/static-1.37718",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1558",
  "html-to-image": "/html-to-image/static-1.61",
  "redux-toolkit": "/redux-toolkit/static-1.78",
  "salesImages": "/salesImages/static-1.593",
  "ui-universal-auth": "/ui-universal-auth/static-1.9451",
  "urlinator": "/urlinator/static-1.4863",
  "video-components": "/video-components/static-1.14193",
  "video-embed": "/video-embed/static-1.36683",
  "ts-schema": "/ts-schema/static-1.4316",
  "ContentData": "/ContentData/static-1.69254",
  "layout-data-lib": "/layout-data-lib/static-1.10309",
  "react-dnd-compat": "/react-dnd-compat/static-1.4949",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1878",
  "external-options-client-types": "/external-options-client-types/static-1.4363",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7226",
  "hs-promise-utils": "/hs-promise-utils/static-1.5923",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4070",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9288",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3397",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11478",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5780",
  "magpie-types": "/magpie-types/static-1.5240",
  "simple-logging-lib": "/simple-logging-lib/static-1.3383",
  "avatar-components": "/avatar-components/static-1.2814",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10163",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6916",
  "flux-actions": "/flux-actions/static-1.372",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5209",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14518",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5941",
  "laboratory-lib": "/laboratory-lib/static-3.7486",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8110",
  "redux-observable": "/redux-observable/static-1.75",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10601",
  "unified-auth": "/unified-auth/static-1.965",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.790",
  "breeze-engine-core": "/breeze-engine-core/static-1.1090",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.86",
  "pulse": "/pulse/static-1.961",
  "navigation-messaging": "/navigation-messaging/static-1.8210",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13295",
  "content-media-compositions": "/content-media-compositions/static-2.17302",
  "idb-keyval": "/idb-keyval/static-1.51",
  "media-bridge-lib": "/media-bridge-lib/static-1.19441",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1247",
  "social-insights-client-types": "/social-insights-client-types/static-1.22706",
  "advanced-menus-core": "/advanced-menus-core/static-1.15614",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12487",
  "ExportDialog": "/ExportDialog/static-6.10711",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34891",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4039",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4370",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.345",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4244",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7131",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3930",
  "persist-promise": "/persist-promise/static-1.4035",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6016",
  "reactive-lib": "/reactive-lib/static-1.1050",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.668",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3341",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.515",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1487",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.15",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1078",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.193",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.534",
  "slack-ui-library": "/slack-ui-library/static-1.10731",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.464",
  "event-emitter": "/event-emitter/static-1.1288",
  "fast-json-patch": "/fast-json-patch/static-1.70",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.4084",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15613",
  "simple-menus-lib": "/simple-menus-lib/static-1.17130",
  "settings-ui-lib": "/settings-ui-lib/static-1.12857",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3796",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10148",
  "react-flip-move": "/react-flip-move/static-1.78"
}
};
